import ConfirmModal from 'views/components/ConfirmModal'

import useRemovePermissionHandler from '../../../effects/remove-permission-from-role'
import { Role, PermissionMeta } from '../../../../../../../graphql'
import { heapEvent } from '@equipmentshare/heaper'

export type RemovePermissionModalProps = {
	onCancel: () => void,
	onSuccess: () => void,
	role: Role,
	permission: PermissionMeta,
}

export default function RemovePermissionModal( { onCancel, onSuccess, role, permission }: RemovePermissionModalProps ) {
	const removePermission = useRemovePermissionHandler()

	const handleSubmit = async() => {
		heapEvent( 'Inventory - Remove Permissions from Role Modal - Click - Remove', {} )
		if ( permission.name ) {
			await removePermission( role, permission.name )
		}
	}

	const handleCancel = () => {
		heapEvent( 'Inventory - Remove Permissions from Role Modal - Click - Cancel', {} )
		onCancel()
	}

	return (
		<ConfirmModal
			message={`You are about to remove "${permission.friendlyName}" from "${role.name}". Do you want to proceed?`}
			onConfirm={async() => await handleSubmit()}
			buttonColor="danger"
			buttonText="Remove"
			onCancel={handleCancel}
			onSuccess={onSuccess}
		/>
	)
}
